import { render, staticRenderFns } from "./PacklistBody.vue?vue&type=template&id=e81c5bc4"
import script from "./PacklistBody.vue?vue&type=script&lang=js"
export * from "./PacklistBody.vue?vue&type=script&lang=js"
import style0 from "./PacklistBody.vue?vue&type=style&index=0&id=e81c5bc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports